import { call, put } from 'redux-saga/effects'

import { UpdateCategoryInputInterface } from '../../../interfaces/category'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { requestFailure, updateCategorySucceed } from '../actions'

export function* updateCategorySaga(
  categoryApi: {
    updateCategory: (...args: any[]) => any
  },
  {
    payload: { categoryId, categoryDetail }
  }: {
    payload: {
      categoryId: string
      categoryDetail: UpdateCategoryInputInterface
    }
  }
) {
  try {
    const { data } = yield call(
      categoryApi.updateCategory,
      categoryId,
      categoryDetail
    )
    yield put(updateCategorySucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
